export function dateFormat(fmt: string, date: any) {
  if (!date) {
    return "-";
  }
  if (typeof date === "string" || typeof date === "number") {
    date = new Date(date);
  }
  let ret;
  const opt: any = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
  };
  for (const k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}

// 本周：获取输入日期的本周一到本周日时间
export function getCurrentWeek(date?: any) {
  if (!date) {
    date = new Date();
  } else {
    if (typeof date === "string" || typeof date === "number") {
      date = new Date(date);
    }
  }
  const start = new Date(
    date.getTime() -
      (date.getDay() === 0 ? 6 : date.getDay() - 1) * 24 * 60 * 60 * 1000
  );
  const end = new Date(
    date.getTime() +
      (date.getDay() === 0 ? 0 : 7 - date.getDay()) * 24 * 60 * 60 * 1000
  );
  return [start, end];
}

// 下周：获取输入日期的下周一到下周日时间
export function getNextWeek(date?: any) {
  if (!date) {
    date = new Date();
  } else {
    if (typeof date === "string" || typeof date === "number") {
      date = new Date(date);
    }
  }
  // 下周一时间 = 当前时间戳 + (当前离下周一的天数 * 时间戳)，0 代表周日
  const start = new Date(
    date.getTime() +
      (date.getDay() === 0 ? 1 : 7 - date.getDay() + 1) * 24 * 60 * 60 * 1000
  );
  // 下周日时间 = 当前时间戳 + (当前离下周日的天数 * 时间戳)
  const end = new Date(
    date.getTime() +
      (date.getDay() === 0 ? 7 : 7 - date.getDay() + 7) * 24 * 60 * 60 * 1000
  );
  return [start, end];
}

// 获取输入日期的上个月开头到结束
export function getLastMonth(date?: any) {
  const y = date.getFullYear();
  let m = date.getMonth();
  m = m < 10 ? "0" + m : m;
  // 设置为日期1号
  date.setDate(1);
  let firstDay = date.getDate();
  firstDay = firstDay < 10 ? "0" + firstDay : firstDay;
  const start = [y, m, firstDay].join("/");

  // 获取当前月的最后一天,参数 0 代表上个月的最后一天
  const lastDay = new Date(y, m, 0).getDate();
  const end = [y, m, lastDay].join("/");
  return [new Date(start), new Date(end)];
}

// 本月：获取输入日期的当月开头到结束
export function getCurrentMonth(date?: any) {
  if (!date) {
    date = new Date();
  } else {
    if (typeof date === "string" || typeof date === "number") {
      date = new Date(date);
    }
  }
  const start = `${date.getFullYear()}/${date.getMonth() + 1}/1`;
  let end = "";
  let m = date.getMonth();
  let y = date.getFullYear();
  if (m === 11) {
    m = 1;
    y = y + 1;
  } else {
    m = m + 2;
  }
  const next = new Date(
    new Date(`${y}/${m}/1`).getTime() - 24 * 60 * 60 * 1000
  );
  end = `${next.getFullYear()}/${next.getMonth() + 1}/${next.getDate()}`;
  return [new Date(start), new Date(end)];
}

// 本季度：获取输入日期的本季度日期
export function getCurrentSeason(date?: any) {
  if (!date) {
    date = new Date();
  } else {
    if (typeof date === "string" || typeof date === "number") {
      date = new Date(date);
    }
  }
  // 获取当前季度：一年有4个季度，每个季度3个月，那么除3，如果整除就是刚好季度末月，否则就是季度中间月份要加一才是季度。
  const currentMonth = new Date().getMonth() + 1;
  const currentQuarter = Math.floor(
    currentMonth % 3 == 0 ? currentMonth / 3 : currentMonth / 3 + 1
  );
  let start = "";
  let end = "";
  if (currentQuarter === 1) {
    start = `${date.getFullYear()}/1/1`;
    end = `${date.getFullYear()}/3/31`;
  }
  if (currentQuarter === 2) {
    start = `${date.getFullYear()}/4/1`;
    end = `${date.getFullYear()}/6/30`;
  }
  if (currentQuarter === 3) {
    start = `${date.getFullYear()}/7/1`;
    end = `${date.getFullYear()}/9/30`;
  }
  if (currentQuarter === 4) {
    start = `${date.getFullYear()}/10/1`;
    end = `${date.getFullYear()}/12/31`;
  }
  return [new Date(start), new Date(end)];
}

// 获取当前n个月前的1号
export function getLatestMonth(n: number) {
  n = n - 1;
  const now = new Date();
  const decY = Math.floor(n / 12);
  const decM = n % 12;
  let y = now.getFullYear();
  let m = now.getMonth() + 1;
  const d = now.getDate();
  if (m <= n) {
    m = m + 12 - decM;
    y = y - 1;
  } else {
    m = m - decM;
  }
  if (m === 13) {
    m = 12;
  }
  return `${y - decY}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
}

// 计算年龄，x年y月
export function getAge(b: number) {
  let yearResult = 0;
  let monthResult = 0;
  const brithday = new Date(b);
  const brithdayY = brithday.getFullYear();
  let brithdayM = brithday.getMonth() + 1;
  let brithdayD = brithday.getDate();
  const now = new Date();
  const nowY = now.getFullYear();
  let nowM = now.getMonth() + 1;
  let nowD = now.getDate();
  // 2月29日闰日生日当作3月1日处理
  if (brithdayM === 2 && brithdayD === 29) {
    brithdayM = 3;
    brithdayD = 1;
  }
  if (nowM === 2 && nowD === 29) {
    nowM = 3;
    nowD = 1;
  }
  if (nowY - brithdayY > 1) {
    // 跨两年以上
    yearResult = nowY - brithdayY;
  } else if (nowY - brithdayY === 1) {
    // 跨一年
    const m = nowM + 12 - brithdayM;
    if (m > 12) {
      yearResult = 1;
    } else if (m === 12) {
      if (nowD >= brithdayD) {
        yearResult = 1;
      } else {
        monthResult = 11;
      }
    } else {
      if (nowD >= brithdayD) {
        monthResult = m;
      } else {
        monthResult = m - 1;
      }
    }
  } else {
    // 同年
    if (nowD >= brithdayD) {
      monthResult = nowM - brithdayM;
    } else {
      monthResult = nowM - brithdayM - 1;
    }
  }
  return [yearResult, monthResult];
}
